import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import media from '../../../services/generateMediaQueries'
import Icon from '../../ui/Icon/Icon'
import ActionButton from '../../ui/ActionButton/ActionButton'
import ExternalLinkButton from '../../ui/ExternalLinkButton/ExternalLinkButton'
import { APP_NAME } from '../../../static/constants'

const StyledReactModal = styled(ReactModal)`
  // display: flex;
  // justify-content: center;
  // align-items: center;

  &:focus {
    outline: 0;
    border: none;
  }
  &.ReactModal__Overlay {
    // width: 100%;
    // height: 100% !important;
    transition: all var(--animation-duration) var(--animation-easing);
  }
  &.ReactModal__Content {
    width: 450px;
    position: absolute;
    top: calc(50% - (${props => props.height}px / 2));
    left: calc(50% - (450px / 2));
    &--after-open {
      opacity: 1;
      transition: opacity var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: opacity calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const ModalContentWrapper = styled.div`
  // overflow: auto;
  // max-height: 100vh;
  // width: 100%;
  // width: 0;
  &:focus {
    outline: 0;
    border: none;
  }
`

const DefaultCloseButton = styled.button`
  position: absolute;
  border: 0;
  top: 15px;
  right: 15px;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  position: relative;
  // margin: 20% calc(50% - (450px / 2));
  // width: 450px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    height: 100%;
    width: 100%;
    border-radius: 0;
  `}
`

const Content = styled.div`
  padding: 3rem 2rem 2rem;
`

const Buttons = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;

  ${({ isError }) => isError && `grid-template-columns: auto;`}

  ${media.lessThan('small')`
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;

    ${({ isError }) => isError && `grid-template-rows: auto;`}
  `}
`

const Title = styled.h3`
  font-family: var(--font-family-ayala-display-sans);
  color: var(--color-primary);
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.5625rem;
  text-align: center;
  margin: 1rem 0;
  position: relative;
  z-index: 1;
`

const Description = styled.p`
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.3125rem;
  margin: 2rem 0;
  padding: 0 1.6875rem;
  text-align: center;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const StyledActionButton = styled(ActionButton)`
  padding: 0;
  span {
    font-weight: var(--font-weight-boldest);
  }
`

const StyledLinkButton = styled(ExternalLinkButton)`
  padding: 0;
`

const content = {}

function ExternalRedirectModal(props) {
  const [componentHeight, setComponentHeight] = React.useState(365)
  const {
    show,
    to,
    onClose,
    onAltClose,
    onProceed,
    zIndex,
    shouldCloseOnOverlayClick = true,
    description,
    isEngagement,
    additionalDesc,
    altCloseTitle,
    altHeader,
    altDesc,
    isError,
    errorMessage,
    ...restProps
  } = props

  const contentRef = React.useCallback(node => {
    if (node !== null) {
      setComponentHeight(node.getBoundingClientRect().height)
    }
  }, [])

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      height={componentHeight}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper ref={contentRef}>
        <ModalContent>
          <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
            <Icon name="x" />
          </DefaultCloseButton>
          <Content>
            <Title>
              {' '}
              {!isError
                ? altHeader || `You are about to leave ${APP_NAME}`
                : 'Error'}
            </Title>
            <Description>
              {!isError
                ? altDesc ||
                  (isEngagement
                    ? 'By clicking proceed, you agree to be redirected to a website operated by 3rd party merchant/s. Any transactions shall be subject to their terms and conditions.'
                    : 'By clicking proceed, you agree to be redirected to a website operated by Giftaway. Any e-Gift transaction with Giftaway shall be subject to their terms and conditions.')
                : errorMessage || 'An error occured.'}
            </Description>
            <Description>{!isError && additionalDesc}</Description>
            <Buttons isError={isError}>
              {!isError ? (
                <>
                  <StyledActionButton onClick={onAltClose || onClose}>
                    {altCloseTitle || 'Cancel'}
                  </StyledActionButton>
                  <StyledLinkButton
                    variant="primary"
                    href={to}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onProceed}
                  >
                    Proceed
                  </StyledLinkButton>
                </>
              ) : (
                <StyledActionButton onClick={onAltClose || onClose}>
                  Ok
                </StyledActionButton>
              )}
            </Buttons>
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

ExternalRedirectModal.defaultProps = {
  // TODO: specify default props
}

ExternalRedirectModal.propTypes = {
  // TODO: specify prop types
}

export default ExternalRedirectModal
